// Central smooth-scroll helper wired to the active Lenis instance.
let instance = null;

export const setLenisInstance = (l) => {
  instance = l;
  if (typeof window !== "undefined") window.__lenis = l;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (instance) {
    instance.scrollTo(el, { offset: -72, duration: 1.1 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
